import axios from 'axios'
import config from 'envVariables'

const axiosInstance = axios.create({
  baseURL: config.baseURL,
})

export default axiosInstance
